// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'url-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import Login from './components/Login'
import Metrics from './components/Metrics'
import Partnerships from './components/Partnerships'
import Payments from './components/Payments'
import UserSettings from './components/UserSettings'
import store from './store'
import _ from 'lodash'

function init() {
  const Firebase = window.firebase

  window.db = Firebase.firestore()
  window.vuexStore = store

  // TODO: sometimes prod
  Vue.config.productionTip = false

  Vue.use(VueRouter)

  const router = new VueRouter({
    mode: 'history',
    routes: [
      { path: '/login', component: Login },
      { path: '/dashboard/',
        component: App,
        children: [
          { path: '', component: Metrics },
          { path: 'partnerships', component: Partnerships },
          { path: 'payments', component: Payments },
          { path: 'settings', component: UserSettings }
        ]
      }
    ]
  })

  /* eslint-disable no-new */
  new Vue({
    store,
    router
  }).$mount('#app')

  // Authentication
  let loginRedirect = window.location.pathname
  Firebase.auth().onAuthStateChanged(function (user) {
    // user change is expected on every page load
    console.log('user changed')
    store.dispatch('setUser', {
      user: user && {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName
      }
    })

    // go to login screen if logged out, and dashboard if logged in
    if (user === null) {
      router.replace('/login')
    } else if (!_.startsWith(router.currentRoute.fullPath, '/dashboard')) {
      if (_.startsWith(loginRedirect, '/dashboard')) {
        router.replace(loginRedirect)
        loginRedirect = null
      } else {
        router.replace('/dashboard')
      }
    }
  }, function (error) {
    console.log(error)
  })
}

window.Raven.context(function () {
  init()
})



// WEBPACK FOOTER //
// ./src/main.js